import React, { useState } from "react";
import TextField from "../components/Input/TextField";
import { useAuth } from "../contexts/AuthContext";
import { toast } from "react-toastify";

const Register = () => {
  const { register } = useAuth();
  const [formData, setFormData] = useState({
    username: "",
    email: "",
    password: "",
    passwordAgain: "",
    isAdmin: false,
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.password !== formData.passwordAgain) {
      toast.error("Şifreler uyuşmuyor!");
      return;
    }

    setLoading(true);
    const res = await register(formData);
    setLoading(false);

    if (res?.status === "failed") {
      toast.error("Kayıt işlemi başarısız: " + res.message);
    } else if(res?.status === "success" ){
      toast.success("Kayıt başarılı!");
      navigator("/user")
    } else {
        toast.error("Bir Hata Oluştu")
    }
  };

  return (
    <div className="h-[89vh] flex">
      <form
        onSubmit={handleSubmit}
        className="flex flex-col gap-2 p-4 rounded-xl w-80 m-auto"
      >
        <h1 className="mb-8 text-2xl font-semibold text-gray-300">Kullanıcı Oluştur</h1>
        <TextField
          type="text"
          name="username"
          placeholder="Kullanıcı Adı"
          value={formData.username}
          onChange={handleChange}
          required
        />
        <TextField
          type="email"
          name="email"
          placeholder="E-posta"
          value={formData.email}
          onChange={handleChange}
          required
        />
        <TextField
          type="password"
          name="password"
          placeholder="Parola"
          value={formData.password}
          onChange={handleChange}
          required
        />
        <TextField
          type="password"
          name="passwordAgain"
          placeholder="Parola Tekrar"
          value={formData.passwordAgain}
          onChange={handleChange}
          required
        />

        <label className="flex items-center gap-2 text-sm cursor-pointer">
          <input
            className="checkbox rounded"
            type="checkbox"
            name="isAdmin"
            checked={formData.isAdmin}
            onChange={handleChange}
          />
          Admin olarak kaydet
        </label>

        <button
          type="submit"
          className="bg-blue-500 text-white p-2 rounded mt-12"
          disabled={loading}
        >
          {loading ? "Kayıt yapılıyor..." : "Kayıt Et"}
        </button>
      </form>
    </div>
  );
};

export default Register;